import range from "lodash/fp/range";
import { useState } from "react";

interface IPaginationProps<T> {
  items: T[];
  itemsPerPage: number;
}

export default function usePagination<T = any>(props: IPaginationProps<T>) {
  const [currentPage, setCurrentPage] = useState<number>(1);

  const maxPages = Math.ceil(props.items.length / props.itemsPerPage);
  const pages = range(1, maxPages + 1);

  const hasNextPage = pages.length > 1 && pages.includes(currentPage + 1);
  const hasPreviousPage = pages.length > 1 && currentPage > 1 && pages.includes(currentPage - 1);

  return {
    items: props.items,
    itemsPerPage: props.itemsPerPage,
    pages,
    currentItems: [...props.items].splice((currentPage - 1) * props.itemsPerPage, props.itemsPerPage),
    currentPage,
    setCurrentPage,
    hasNextPage,
    hasPreviousPage,
    goToNextPage: () => setCurrentPage(hasNextPage ? currentPage + 1 : currentPage),
    goToPreviousPage: () => setCurrentPage(hasPreviousPage ? currentPage - 1 : currentPage),
  };
}
